import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/dashboard/results/income")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
